export default "__VITE_ASSET__DEOVAmET__"